import React from "react";
import {
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Autocomplete,
  TextField,
  Box,
  Button,
} from "@mui/material";
import config from "src/config";
import SectionSelectList from "src/components/add-section-input";
import { getMyCompanyDetails, updateMyCompanyDetails } from "src/services/company.service";
import showLoading from "src/common/loading";
import Swal from "sweetalert2";

const FILE_OPTIONS = [
  { value: "{manual_input}", label: "Manual Input" },
  { value: "{date}", label: "Date" },
  { value: "{time}", label: "Date Time" },
  { value: "{version}", label: "Version" },
];

const CONTAINER_OPTIONS = [
  { value: "{manual_input}", label: "Manual Input" },
  { value: "{date}", label: "Date" },
  { value: "{time}", label: "Date Time" },
];

export default class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timezone: null,
      time_format: null,
      date_format: null,
      work_week_days: null,
      work_week_off_days: null,
      file_naming_convention: [],
      container_naming_convention: [],
    };
  }

  componentDidMount(){
    this.getSettingsData();
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  getSettingsData = async () => {
    try {

      let settingsDetails = await getMyCompanyDetails();

      if (settingsDetails.error) {
        console.log("Error fetching settingsDetails:", settingsDetails.error);
        return;
      }
      this.setState({
        ...settingsDetails?.company?.settings
      });

    } catch (error) {
      console.error("Error fetching container suggestions:", error);
    }
  }

  saveSettingsDetails = async () => {
    try {
      let payload={
        settings:{
          ...this.state
        }
      }
      let saveSettingsDetails = await updateMyCompanyDetails(payload);

      if (saveSettingsDetails.error) {
        showLoading(false);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: saveSettingsDetails.error,
          confirmButtonText: 'Ok',
          confirmButtonColor: config.primaryColor
        });
        return;
      }
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: saveSettingsDetails?.company?.message,
        confirmButtonText: 'Ok',
        confirmButtonColor: config.primaryColor
      });

    } catch (error) {
      console.error("Error fetching container suggestions:", error);
    }
  }

  handleSave = () => {
    this.saveSettingsDetails()
  };

  render() {
    return (
      <Container disableGutters>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Time zone</InputLabel>
              <Select
                value={this.state?.timezone || ""}
                label="Time zone"
                onChange={(e) =>
                  this.setStateAsync({ timezone: e.target.value })
                }
              >
                {config?.timeZones?.map((timeZone) => (
                  <MenuItem key={timeZone?.value} value={timeZone?.value}>
                    {timeZone?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Time format</InputLabel>
              <Select
                value={this.state?.time_format || ""}
                label="Time format"
                onChange={(e) =>
                  this.setStateAsync({ time_format: e.target.value })
                }
              >
                {config?.timeFormats?.map((timeFormat) => (
                  <MenuItem key={timeFormat?.value} value={timeFormat?.value}>
                    {timeFormat?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Date format</InputLabel>
              <Select
                value={this.state?.date_format || ""}
                label="Date format"
                onChange={(e) =>
                  this.setStateAsync({ date_format: e.target.value })
                }
              >
                {config?.dateFormats?.map((dateFormat) => (
                  <MenuItem key={dateFormat?.value} value={dateFormat?.value}>
                    {dateFormat?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={config?.workingDays || []}
              getOptionLabel={(option) => option.label}
              value={
                config?.workingDays.filter((day) =>
                  (this.state?.work_week_days || []).includes(day.value)
                ) || []
              }
              onChange={(e, newValue) =>
                this.setStateAsync({
                  work_week_days: newValue.map((day) => day.value),
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="Week work days"
                  placeholder="Select days"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={config?.nonWorkingDays || []}
              getOptionLabel={(option) => option.label}
              value={
                config?.nonWorkingDays.filter((day) =>
                  (this.state?.work_week_off_days || []).includes(day.value)
                ) || []
              }
              onChange={(e, newValue) =>
                this.setStateAsync({
                  work_week_off_days: newValue.map((day) => day.value),
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="Weekly off"
                  placeholder="Select days"
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <SectionSelectList
            title="File Naming Convention"
            options={FILE_OPTIONS}
            onChange={(data)=>this.setStateAsync({file_naming_convention:data})}
            items={this.state?.file_naming_convention}
          />
          <SectionSelectList
            title="Container Naming Convention"
            options={CONTAINER_OPTIONS}
            onChange={(data)=>this.setStateAsync({container_naming_convention:data})}
            items={this.state?.container_naming_convention}
          />
        </Grid>
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Button variant="contained" color="primary" onClick={this.handleSave}>
            Save
          </Button>
        </Box>
      </Container>
    );
  }
}
